export const GET_SUBSCRIPTION_HOME = 'providers/SuscriptionProvider/GET_SUBSCRIPTION_HOME';
export const DELETE_PAYMENT_METHOD = 'providers/SuscriptionProvider/DELETE_PAYMENT_METHOD';
export const SAVE_PAYMENT_METHOD = 'providers/SuscriptionProvider/SAVE_PAYMENT_METHOD';
export const GET_SUBSCRIPTION_PYMENTS = 'providers/SuscriptionProvider/GET_SUBSCRIPTION_PYMENTS';
export const GET_SUBSCRIPTION_PYMENTS_BY_PAGINATION =
  'providers/SuscriptionProvider/GET_SUBSCRIPTION_PYMENTS_BY_PAGINATION';
export const GET_SUBSCRIPTION_INVOICE_DATA = 'providers/SuscriptionProvider/GET_SUBSCRIPTION_INVOICE_DATA';
export const UPDATE_SUBSCRIPTION_INVOICE_DATA = 'providers/SuscriptionProvider/UPDATE_SUBSCRIPTION_INVOICE_DATA';
